import { DAUM_POSTCODE_SCRIPT_URL } from "@/common/constant/daum-postcode-script-url";
import { ButtonColor } from "@/common/enum/button-color";
import { SearchOutlineIcon } from "@/components/icon/SearchOutlineIcon";
import { Button } from "flowbite-react";
import { Address, useDaumPostcodePopup } from "react-daum-postcode";

interface Props {
  setAddress: (address: Address) => void;
}

export const AddressSearchButton: React.FC<Props> = ({ setAddress }) => {
  const open = useDaumPostcodePopup(DAUM_POSTCODE_SCRIPT_URL);

  const handleComplete = (address: Address) => {
    setAddress(address);
  };

  const handleSearchAddressButtonClick = () => {
    open({ onComplete: handleComplete });
  };

  return (
    <Button
      className="w-[48px] h-[40px]"
      color={ButtonColor.PRIMARY}
      onClick={handleSearchAddressButtonClick}
    >
      <SearchOutlineIcon color="text-primary-white" size={18} />
    </Button>
  );
};
